import { faDownload,faBarsStaggered, faClose, faCode, faMoon, faSun } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from "react";
import NizResume from '../assets/pdf/Niyaz-Resume.pdf';

function Head({ isScrolled , activeMenu, navigateMenu, lightMode, setLightMode }){

    const [menu, setMenu] = React.useState(false);

    const handleNavigateMenu = (el,id,section) => {
      el.preventDefault();
      navigateMenu(id,section);
      setMenu(false);
    }
  
    const toggleMenu = () =>{
      setMenu(!menu);
    }

    const handleModeToggle = () =>{
      setLightMode(prev => !prev);
    }
    
    const openPDF = () =>{
      const pdfPath = NizResume;
      window.open(pdfPath, '_blank');
    }

    React.useEffect(() =>{

      document.documentElement.style.setProperty('--scrollbar-bg', lightMode ? '#beb7e6': '#1F2937');

    },[lightMode])

    React.useEffect(() => {
      if (!menu) return;

      const onKeyDown = (e) => {
        if (e.key === 'Escape') setMenu(false);
      };

      window.addEventListener('keydown', onKeyDown);
      const prevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';

      return () => {
        window.removeEventListener('keydown', onKeyDown);
        document.body.style.overflow = prevOverflow;
      };
    }, [menu]);
    
    return(
    <header className={` ${ isScrolled ? "sticky animate-fade-from-top w-full shadow-md shadow-gray-700 top-0 relative":' md:absolute md:top-9 bg-transparent'} ${lightMode ? "bg-gray-200":"bg-gray-900"} z-10 w-11/12 mx-auto animate-fade-from-top py-8 md:left-10 lg:left-24  relative`}>
      <div className="lg:mx-auto lg:w-11/12">
        <nav className="flex justify-around md:justify-between transform items-center relative">
          
           {/* Logo */}
            <div className="flex items-end">
              <a href="/"><span className="text-6xl third-color md:text-5xl font-bold mr-1 animate-n animate-bounce">N</span>
              <span className={`text-4xl ${lightMode ? "text-black":"text-white"}  md:text-4xl font-semibold `}>iyaz</span> <FontAwesomeIcon className="pl-2 third-color animate-bounce text-white" icon={faCode} /></a>
            </div>
            {/* Desktop menu */}
            <div className="hidden md:flex items-center md:m-auto">
              <div className="flex md:items-center md:flex-row w-full md:w-auto space-x-8">
                  <a href="/" className={`${activeMenu === 'bio' ? 'third-color font-bold' : `${lightMode ? "text-black hover:text-white":"text-gray-100"}` } px-4 py-2 transition hover:third-color hover:bg-gray-700 rounded`} onClick={(e) => handleNavigateMenu(e,0,'bio')} >Bio</a>
                  <a href="/" className={`${activeMenu === 'what-i-do' ? 'third-color font-bold' : `${lightMode ? "text-black hover:text-white":"text-gray-100"}` } px-4 py-2 transition hover:bg-gray-700 rounded`} onClick={(e) => handleNavigateMenu(e,1,'what-i-do')}>What I Do</a>
                  <a href="/" className={`${activeMenu === 'portfolio' ? 'third-color font-bold' : `${lightMode ? "text-black hover:text-white":"text-gray-100"}` } px-4 py-2 transition hover:bg-gray-700 rounded`} onClick={(e) => handleNavigateMenu(e,2,'portfolio')}>Portfolio</a>
                  <a href="/" className={`${activeMenu === 'skills' ? 'third-color font-bold' : `${lightMode ? "text-black hover:text-white":"text-gray-100"}` } px-4 py-2 transition hover:bg-gray-700 rounded`} onClick={(e) => handleNavigateMenu(e,3,'skills')}>Skills</a>
                  <a href="/" className={`${activeMenu === 'contact_us' ? 'third-color font-bold' : `${lightMode ? "text-black hover:text-white":"text-gray-100"}` } px-4 py-2 transition hover:bg-gray-700 rounded`} onClick={(e) => handleNavigateMenu(e,4,'contact_us')}>Contact</a>
              </div>
            </div>
            
      
        <button onClick={openPDF} className="hidden md:block bg-gradient-to-r from-teal-600 to-blue-700  text-white px-6 py-2 rounded hover:bg-pink-700 transition">
          Download CV <FontAwesomeIcon icon={faDownload} /> 
        </button>
        <button onClick={handleModeToggle}
            className={`relative ml-5 inline-flex items-center w-16 h-8 rounded-full transition-colors duration-300 focus:outline-none focus:ring-0 focus:ring-offset-0 focus:ring-blue-500 ${
              lightMode ? 'bg-gray-400 ' : 'bg-blue-800'}`} aria-label="Toggle dark mode" >
              <span className={`inline-block w-6 h-6 transform transition-transform duration-300 ease-in-out bg-white rounded-full shadow-lg ${ 
                  lightMode ? 'translate-x-8' : 'translate-x-1' }`}
              />
              {/* Moon Icon */}
              <FontAwesomeIcon icon={faMoon} className={`absolute left-1.5 top-1.5 w-5 h-5 transition-opacity duration-300 ${ lightMode ? 'opacity-0 text-gray-400' : 'opacity-100 text-gray-900'}`}
              />
              {/* Sun Icon */}
              <FontAwesomeIcon icon={faSun} className={`absolute right-2 top-1.5 w-5 h-5 pr-0.5 transition-opacity duration-300 ${ lightMode ? 'opacity-100 text-yellow-400' : 'opacity-0 text-gray-400'}`}
              />
        </button>
        <button
          type="button"
          className={`md:hidden ${lightMode ? "text-gray-900" : "text-white"}`}
          onClick={toggleMenu}
          aria-label={menu ? "Close menu" : "Open menu"}
          aria-expanded={menu}
        >
          {menu ? <FontAwesomeIcon size="2x" icon={faClose} /> : <FontAwesomeIcon size="2x" icon={faBarsStaggered} className="transition-all duration-300 ease-in-out" />}
        </button>
        </nav>

        {/* Mobile full-screen menu (blob reveal) */}
        <div
          className={`md:hidden fixed inset-0 z-50 transition-[clip-path,opacity] duration-500 ease-[cubic-bezier(0.22,1,0.36,1)] [will-change:clip-path] ${
            menu
              ? 'opacity-100 pointer-events-auto [clip-path:circle(150%_at_92%_10%)]'
              : 'opacity-0 pointer-events-none [clip-path:circle(0%_at_92%_10%)]'
          }`}
          role="dialog"
          aria-modal="true"
          aria-hidden={!menu}
        >
          {/* Click outside to close */}
          <button
            type="button"
            className="absolute inset-0 cursor-default"
            onClick={() => setMenu(false)}
            aria-label="Close menu overlay"
          />

          <div className={`relative h-full ${lightMode ? 'bg-gray-200' : 'bg-gray-900'}`}>
            {/* Decorative blob */}
            <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-gradient-to-br from-[#FC0449] via-purple-600 to-blue-600 blur-2xl opacity-80" />

            <div className="relative flex h-full flex-col px-6 pt-8">
              <div className="flex items-center justify-between">
                <span className={`text-xl font-semibold ${lightMode ? 'text-black' : 'text-white'}`}>Menu</span>
                <button
                  type="button"
                  className={`${lightMode ? "text-black" : "text-white"}`}
                  onClick={() => setMenu(false)}
                  aria-label="Close menu"
                >
                  <FontAwesomeIcon size="2x" icon={faClose} />
                </button>
              </div>

              <div className="mt-10 flex flex-col gap-3">
                <a
                  href="/"
                  className={`rounded-xl px-4 py-4 text-lg font-semibold transition-all duration-300 ${
                    menu ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'
                  } ${activeMenu === 'bio' ? 'third-color' : `${lightMode ? 'text-gray-900' : 'text-gray-100'}`} hover:bg-gray-700/40`}
                  onClick={(e) => handleNavigateMenu(e,0,'bio')}
                >
                  Bio
                </a>
                <a
                  href="/"
                  className={`rounded-xl px-4 py-4 text-lg font-semibold transition-all duration-300 delay-75 ${
                    menu ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'
                  } ${activeMenu === 'what-i-do' ? 'third-color' : `${lightMode ? 'text-gray-900' : 'text-gray-100'}`} hover:bg-gray-700/40`}
                  onClick={(e) => handleNavigateMenu(e,1,'what-i-do')}
                >
                  What I Do
                </a>
                <a
                  href="/"
                  className={`rounded-xl px-4 py-4 text-lg font-semibold transition-all duration-300 delay-100 ${
                    menu ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'
                  } ${activeMenu === 'portfolio' ? 'third-color' : `${lightMode ? 'text-gray-900' : 'text-gray-100'}`} hover:bg-gray-700/40`}
                  onClick={(e) => handleNavigateMenu(e,2,'portfolio')}
                >
                  Portfolio
                </a>
                <a
                  href="/"
                  className={`rounded-xl px-4 py-4 text-lg font-semibold transition-all duration-300 delay-150 ${
                    menu ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'
                  } ${activeMenu === 'skills' ? 'third-color' : `${lightMode ? 'text-gray-900' : 'text-gray-100'}`} hover:bg-gray-700/40`}
                  onClick={(e) => handleNavigateMenu(e,3,'skills')}
                >
                  Skills
                </a>
                <a
                  href="/"
                  className={`rounded-xl px-4 py-4 text-lg font-semibold transition-all duration-300 delay-200 ${
                    menu ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'
                  } ${activeMenu === 'contact_us' ? 'third-color' : `${lightMode ? 'text-gray-900' : 'text-gray-100'}`} hover:bg-gray-700/40`}
                  onClick={(e) => handleNavigateMenu(e,4,'contact_us')}
                >
                  Contact
                </a>
              </div>

              <div className="mt-auto pb-10 pt-8">
                <button
                  onClick={openPDF}
                  className="w-full bg-gradient-to-r from-teal-600 to-blue-700 text-white px-6 py-4 rounded-xl hover:bg-pink-700 transition"
                >
                  Download CV <FontAwesomeIcon icon={faDownload} />
                </button>
              </div>
            </div>
          </div>
        </div>

        </div>
    </header>
    );
}

export default Head;